import React, {Component} from 'react';
import Col from 'react-bootstrap/Col';
import { Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import FastQuotingCabinetDataService from "./services/fastquotingcabinet.service";
import * as FaIcons from "react-icons/fa";
import { Button, Container, FormControl, FormLabel } from 'react-bootstrap';
import FastQuotingCabinetsList from './FastQuotingCabinetsList';
import TopAndSideBar from './TopAndSideBar';
import { NewHeader } from './AuxiliaryFunctions';

var newDate = new Date()
var gtDate = newDate.getDate().toString().padStart(2,'0') + '-' + (newDate.getMonth()+1).toString().padStart(2,'0') + '-' + newDate.getFullYear()

class CabinetFastQuote extends Component {

  constructor(props) {
    super(props);
    this.onChangeCabinetFastQuoteFilterByDescr = this.onChangeCabinetFastQuoteFilterByDescr.bind(this);
    this.onChangeSortField = this.onChangeSortField.bind(this);
    this.onChangeSortType = this.onChangeSortType.bind(this);
    this.performSearch = this.performSearch.bind(this);

    this.state = {
      listOfCabinetFastQuotes: null,
      CabinetFastQuoteFilterByDescr: '',
      SortField: 'id',
      SortType: 'ASC'
    };
  }  

  onChangeSortType() {
    this.setState({
      SortType: (this.state.SortType == 'DESC')?'ASC':'DESC'
    });
    this.performSearch(this.state.CabinetFastQuoteFilterByDescr,this.state.SortField,this.state.SortType);    
  }

  onChangeSortField(e) {
    this.setState({
      SortField: e.target.value
    });
    this.performSearch(this.state.CabinetFastQuoteFilterByDescr,e.target.value,this.state.SortType);
  }

  onChangeCabinetFastQuoteFilterByDescr(e) {
    this.setState({
        CabinetFastQuoteFilterByDescr: e.target.value
    });
    this.performSearch(e.target.value,this.state.SortField,this.state.SortType);
  }

  componentDidMount() {
    this.performSearch(this.state.CabinetFastQuoteFilterByDescr, this.state.SortField,this.state.SortType);  
  }

  performSearch = (descr,sortfield,sorttype) => {
    FastQuotingCabinetDataService.getFastQuotingCabinetByDescr(descr,sortfield,sorttype)
      .then(response => {
        console.log(response.data);
        this.setState({
          listOfFastQuotingCabinets: response.data
        });
        console.log(this.state.listOfFastQuotingCabinets);
      })
      .catch(e => {
        console.log(e);
      });
  };

  searchWithEnter = (event)=> {
    if (event.keyCode === 13) {
      this.performSearch();
    }
  }  

  render (){
    return (
      <>
      <div style={{display:"flex", flexDirection:"column",width:"100%"}}>
        <TopAndSideBar />
        <NewHeader headerTitle={"Cabinet Fast Quotes"}/>
        <div style={{padding:"0 8vw",}}>
          <Row className='mb-2 d-flex'>
            <Col lg={true}>
              <FormLabel className='mb-2'>Filter by Quoting number:</FormLabel>       
              <FormControl type="text" name="filterbyquotingnumber" id="filterbyquotingnumber" onChange={this.onChangeCabinetFastQuoteFilterByDescr}></FormControl>
            </Col>
            <Col lg={true}>
              <FormLabel className='mb-2'>Sort By:</FormLabel>       
                <FormControl as='select' onChange={this.onChangeSortField}>
                  <option value="id">Quoting Number</option>
                  <option value="job.jobtitle">Job Name</option>
                </FormControl>
            </Col>
            
            <Col sm={true}>
              <FormLabel className='mb-2'>Asc/Desc:</FormLabel>       
              <FormControl style={{maxWidth:"50px"}} as="button" onClick={this.onChangeSortType}><FaIcons.FaSortAmountDownAlt/></FormControl>
            </Col>          
          </Row>

          <Row className='mb-2 d-flex'>
            <Col>
              <Link to="/new-cabinet-fast-quote" className="mr-2 btn btn-primary">New Cabinet Fast Quote</Link>            
              <Button className="m-2 btn btn-primary">Export</Button>                  
            </Col>
          </Row>        

          <Row>
            <FastQuotingCabinetsList mode={0} listOfFastQuotingCabinets = {this.state.listOfFastQuotingCabinets} />      
          </Row>
        </div>
      </div>
      </>
    )
  }
}

export default CabinetFastQuote;